import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PunchupPersonEntry } from 'features/common/components/Punchup/composites/forms/PunchupPersonEntry';
import { PunchupInputToggle } from 'features/common/components/Punchup/primitives/forms/fields/PunchupInputToggle';
import { PunchupQuantityCard } from '../PunchupQuantityCard/PunchupQuantityCard';
import { RecipientInfoFormProps } from './types';

export const PunchupRecipientInfoForm = ({ ticketTypes, poolBudget }: RecipientInfoFormProps) => {
	const { t } = useTranslation();
	const { watch } = useFormContext();
	const noEmail = !!watch('recipients[0].noEmail');

	return (
		<PunchupPersonEntry
			emailName="recipients[0].email"
			firstNameName="recipients[0].firstName"
			lastNameName="recipients[0].lastName"
			hideEmail={noEmail}
			belowEmail={
				<PunchupInputToggle
					htmlFor="recipients[0].noEmail"
					name="recipients[0].noEmail"
					label={t('send-tickets-no-email', 'Recipient has no email')}
				/>
			}
		>
			<PunchupQuantityCard recipientId={0} ticketTypes={ticketTypes} poolBudget={poolBudget} />
		</PunchupPersonEntry>
	);
};
